import { queryOptions } from '@tanstack/react-query';
import getCartView from '../../api/cart/get-cart-view';
import { cartKeys } from './query-keys';

const STALE_TIME = 5 * 60_000;
const GC_TIME = 5 * 60_000;

// refetchOnWindowFocus/refetchOnReconnect are hard-disabled here (not deferred to FE-251):
// a background refetch must not silently change the cart under the user mid-checkout.
export const cartViewQueryOptions = queryOptions({
    queryKey: cartKeys.view(),
    queryFn: getCartView,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
});
